import NextImage from 'next/image'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import {
  CONVERSATION_MESSAGE_SUGGESTIONS,
  GURU_AI_AVATAR_IMAGE_PATH,
} from 'app/ConversationPage/constants'

interface IConversationSuggestionBubbleProps {
  text: string
  onClick?: () => void
}
const ConversationSuggestionBubble: React.FC<
  IConversationSuggestionBubbleProps
> = ({ text = '', ...props }) => {
  return (
    <button {...props} className="w-full">
      <div className="flex items-center justify-between p-4 text-left rounded-lg bg-default">
        <div>{text}</div>
        <div>
          <Icon className="!text-subdued">arrow_upward</Icon>
        </div>
      </div>
    </button>
  )
}

interface IConversationSuggestionsProps {
  onClick?: (message: string, index: number) => void
}
const ConversationSuggestions: React.FC<IConversationSuggestionsProps> = ({
  onClick = () => {},
}) => {
  return (
    <div className="p-4">
      <div className="pb-6">
        <NextImage
          src={GURU_AI_AVATAR_IMAGE_PATH}
          width="100px"
          height="100px"
        />
      </div>
      <div className="mb-2">
        <Text variant="heading-lg">Butuh diskusi apa hari ini?</Text>
      </div>
      <div className="mb-6">
        <Text color="subdued">Asisten Guru siap memberi ide!</Text>
      </div>

      <div className="space-y-3">
        {CONVERSATION_MESSAGE_SUGGESTIONS.map((text, index) => (
          <ConversationSuggestionBubble
            key={`conversation-suggestion-${index}`}
            text={text}
            onClick={() => onClick(text, index)}
          />
        ))}

        <div className="flex justify-between p-4 space-x-2 rounded-lg bg-surface-informational-subdued">
          <div className="flex-none">
            <NextImage
              src="/icon/tips_and_updates.svg"
              width="24px"
              height="24px"
              alt="Tips Icon"
            />
          </div>
          <div>
            <Text variant="body">
              Anda juga <strong>bisa ketik di bawah</strong> untuk diskusi
              topik-topik pendidikan lain.
            </Text>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConversationSuggestions
